<form [formGroup]="profileForm" class="article-type-masterdata no-field-space">

  <sc-flex>
    <sc-dictionary-field class="input-title" [model]="articleType?.name" [maxlength]="255" [defaultLabel]="'name'"
          [labelDictionaryKey]="'erp.entity.articletype.name'" [required]="true" grow>
      </sc-dictionary-field>
      <sc-content-spacer></sc-content-spacer>
        <!-- Select Box mit allen ArticleTypes -->
        <mat-form-field appearance="fill" style="width: 300px;">
          <mat-label>
            <sc-dictionary-label dictionaryKey="erp.entity.articletype.parentArticleType"></sc-dictionary-label>
          </mat-label>
          <mat-select formControlName="parentArticleTypeId" [value]="_articleType.parentArticleTypeId">
            <mat-option value="0">
              <sc-dictionary-label dictionaryKey="erp.entity.articletype.parentArticleTypeNone"></sc-dictionary-label>
            </mat-option>
              <mat-option *ngFor="let source of articleTypes" [value]="source.id">
                  {{source.title}}
              </mat-option>
          </mat-select>
        </mat-form-field>
  </sc-flex>


    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex >
      <mat-form-field appearance="fill" class="identifierPattern">
        <mat-label>
          <sc-dictionary-label dictionaryKey="erp.entity.articletype.identifierPattern"></sc-dictionary-label>
        </mat-label>
        <input matInput formControlName="identifierPattern">
      </mat-form-field>

      <sc-content-spacer></sc-content-spacer>

      <mat-checkbox name="archived" formControlName="archived">
        <sc-dictionary-label dictionaryKey="erp.entity.articletype.archived"></sc-dictionary-label>
      </mat-checkbox>
    </sc-flex>

</form>
